export default "__VITE_ASSET__DBzRo5W3__"